/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListResponse } from '../models/ListResponse';
import type { NumberCircle } from '../models/NumberCircle';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NumberCircleService {

    /**
     * Get a list of `NumberCircle`s
     * @returns any A list of `NumberCircle`s.
     * @throws ApiError
     */
    public static listNumberCircles({
page,
size,
filter,
sort,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
}): CancelablePromise<ListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/number-circles',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
            },
        });
    }

    /**
     * Create a new `NumberCircle`
     * @returns NumberCircle A single `NumberCircle`.
     * @throws ApiError
     */
    public static createNumberCircle({
requestBody,
}: {
requestBody: NumberCircle,
}): CancelablePromise<NumberCircle> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/number-circles',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get a specific `NumberCircle`
     * @returns NumberCircle A single `NumberCircle`.
     * @throws ApiError
     */
    public static getNumberCircle({
id,
}: {
/**
 * ID of the `NumberCircle`
 */
id: string,
}): CancelablePromise<NumberCircle> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/number-circles/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `NumberCircle`
     * @returns NumberCircle A single `NumberCircle`.
     * @throws ApiError
     */
    public static updateNumberCircle({
id,
requestBody,
}: {
/**
 * ID of the `NumberCircle`
 */
id: string,
requestBody: NumberCircle,
}): CancelablePromise<NumberCircle> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/number-circles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Delete a specific `NumberCircle`
     * @returns void 
     * @throws ApiError
     */
    public static deleteNumberCircle({
id,
}: {
/**
 * ID of the `NumberCircle`
 */
id: string,
}): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/number-circles/{id}',
            path: {
                'id': id,
            },
        });
    }

}
